import { getDeviceIdLocalStorage } from "./device";

export function formatString(str: string) {
  let formattedString = str.toLowerCase();
  formattedString = formattedString.replace(/[^a-z0-9]/g, "");
  return formattedString;
}

export function generateRandomString(length: number) {
  const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}

export const getUtmSource = () => {
  const q = new URLSearchParams(window.location.search);
  return q.get("utm_source") || "";
};

export const getPlayGameDomain = (props?: { idToken?: string }) => {
  const hostname = window.location.hostname;
  const rootHostname = hostname.replace(/^www\./, ""); // strip www. prefix
  const deviceId = getDeviceIdLocalStorage();
  const deviceIdParam = deviceId ? `&deviceId=${deviceId}` : "";
  const domain =
    rootHostname === "localhost"
      ? "https://play.winaz.com/"
      : `https://play.${rootHostname}/`;

  if (props?.idToken) {
    return `${domain}?referer=${encodeURIComponent(
      window.location.origin,
    )}${deviceIdParam}#idToken=${props.idToken}`;
  }

  if (!window?.location?.search)
    return `${domain}?referer=${encodeURIComponent(window.location.origin)}${deviceIdParam}`;

  return (
    domain +
    window.location.search +
    `&referer=${encodeURIComponent(window.location.origin)}${deviceIdParam}`
  );
};

export const getFBP = () => {
  const cookieMatch = document.cookie.match(/_fbp=([^;]+)/);
  if (cookieMatch?.[1]) return cookieMatch[1];

  const ls = localStorage.getItem("_fbp");
  if (ls) return ls;

  return;
};

export const getFBC = () => {
  const cookieMatch = document.cookie.match(/_fbc=([^;]+)/);
  if (cookieMatch?.[1]) return cookieMatch[1];

  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get("fbclid");
  if (!fbclid) return;

  const hostnameSplit = window.location.hostname.split(".");
  const fbc = `fb.${hostnameSplit.length - 1}.${Date.now()}.${fbclid}`;

  // Save cookie (3 months)
  document.cookie = `_fbc=${fbc}; path=/; max-age=${
    60 * 60 * 24 * 90
  }; SameSite=None; Secure`;

  return fbc;
};

export const getTTP = () => {
  const cookieMatch = document.cookie.match(/_ttp=([^;]+)/);
  if (cookieMatch?.[1]) return cookieMatch[1];

  const ls = localStorage.getItem("_ttp");
  if (ls) return ls;

  return;
};

export const getTTCLID = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("ttclid");
};

export const getRichAdsClickId = () => {
  const cookieMatch = document.cookie.match(/richAdsClickId=([^;]+)/);
  if (cookieMatch?.[1]) return cookieMatch[1];

  return;
};

export const getPropellAdsUTMPrid = () => {
  const cookieMatch = document.cookie.match(/prop_visitor_id=([^;]+)/);
  if (cookieMatch?.[1]) return cookieMatch[1];

  return;
};

export const getKeitaroSubid = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("clickid");
};
